import { useSelector } from 'react-redux';
import { RecommendationGender } from '@shared/types/recommendation';
import { getGender } from '@client/redux/modules/customer/selectors';
import { getCategoryTabId, getTabs } from '@client/redux/modules/mylounge';

export const useRecommendationGender = (): RecommendationGender => {
    const tabs = useSelector(getTabs);
    const categoryTabId = useSelector(getCategoryTabId);
    const categoryTabGender = tabs.find(tab => tab.id === categoryTabId)
        ?.gender as RecommendationGender;
    const customerGender = useSelector(getGender)?.toUpperCase() as RecommendationGender;

    return categoryTabGender || customerGender || RecommendationGender.FEMALE;
};
